import {
  FETCH_TMS_TRANSLATIONS,
  FETCH_TMS_CONFIG,
  FETCH_TMS_ERRORS,
  FETCH_TMS_TRANSLATIONS_COMPLETE,
  FETCH_TMS_CONFIG_COMPLETE,
  FETCH_TMS_ERRORS_COMPLETE,
  TMSData,
  TMSLabel
} from './types';
import { remove, get } from 'lodash';

export const tms = (
  state: TMSData = {},
  action: {
    type: string;
    payload?: TMSLabel;
  }
): TMSData => {
  switch (action.type) {
    case FETCH_TMS_TRANSLATIONS:
    case FETCH_TMS_CONFIG:
    case FETCH_TMS_ERRORS:
      return { labels: [...get(state, 'labels', []), { ...action.payload, fetched: false }] };
    case FETCH_TMS_TRANSLATIONS_COMPLETE:
    case FETCH_TMS_CONFIG_COMPLETE:
    case FETCH_TMS_ERRORS_COMPLETE: {
      const { translation, translationSpace, language } = action.payload;
      remove(get(state, 'labels', []), { translation, translationSpace, language });
      return { labels: [...get(state, 'labels', []), { ...action.payload, fetched: true }] };
    }
    default:
      return state;
  }
};
